import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import OpenGeneticReportWizard from '../OpenGeneticReportWizard';

class ChangelogModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: props.isOpen || false
    };

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
  }

  displayRerunMessage() {
    if (this.props.openGeneticReportWizardProps.freeRerun) {
      return "Rerun for Free";
    } else {
      if (this.props.openGeneticReportWizardProps.coupon) {
        return `Upgrade for $${this.props.openGeneticReportWizardProps.minimumAmount/100}`
      } else {
        return "Run New Report";
      }
    }
  }

  open() {
    this.setState({ isOpen: true });
  }

  close() {
    this.setState({ isOpen: false });
  }

  render() {
    return (
      <span>
        <span
          onClick={this.open}
          dangerouslySetInnerHTML={{ __html: this.props.triggerHTML }}
        />
        <Modal
          className="modal"
          style={{
            overflow: 'initial',
            padding: '.5rem 1rem'
          }}
          overlayClassName="overlay"
          isOpen={this.state.isOpen}
        >
          <button className="modal-close" onClick={this.close}>
            ✕ <span>Close</span>
          </button>
          <div
            style={{
              padding: '1em'
            }}
            dangerouslySetInnerHTML={{ __html: this.props.contentHTML }}
          />

          <div className="sticky-footer">
            <hr className="m0 p0" />

            <div className="center mt2 mb2">
              <OpenGeneticReportWizard
                innerHTML={this.displayRerunMessage()}
                className="btn btn-pill btn-primary"
                wizardState={{ ...this.props.openGeneticReportWizardProps }}
              />
            </div>
          </div>

        </Modal>
      </span>
    );
  }
}

ChangelogModal.propTypes = {
  triggerHTML: PropTypes.string.isRequired,
  contentHTML: PropTypes.string.isRequired,
  contentHTML: PropTypes.bool,
  openGeneticReportWizardProps: PropTypes.objectOf(
    PropTypes.shape({
      sessionToken: PropTypes.string,
      stripeKey: PropTypes.string.isRequired,
      minimumAmount: PropTypes.number.isRequired,
      genotypeTemplateId: PropTypes.number,
      isSupporter: PropTypes.bool.isRequired,
      freeRerun: PropTypes.bool.isRequired,
      onClose: PropTypes.func.isRequired,
      coupon: PropTypes.string
    })
  ).isRequired
};

export default ChangelogModal;
